import { render, staticRenderFns } from "./formScore.vue?vue&type=template&id=c53ea1e8&scoped=true&"
import script from "./formScore.vue?vue&type=script&lang=ts&"
export * from "./formScore.vue?vue&type=script&lang=ts&"
import style0 from "./formScore.vue?vue&type=style&index=0&id=c53ea1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53ea1e8",
  null
  
)

export default component.exports